// 'use strict';

import $ from 'jquery';

// import selectize from 'selectize';

class BjzmFormScripts {

	constructor() {
		
		this.init();
		this.is_form_two_open = false;

		this.uploadField = $('.gfield--upload');
		this.uploadText = this.uploadField.find('.gfield_label');

		this.uploadField.on('click', (e) => {
			this.doUpload();
		});

		if ($('body').find('.datepicker').length > 0){
		    jQuery(function() {
	        	jQuery( ".datepicker" ).datepicker({ }).attr('readonly','readonly');
	    	});
		}

		if( $('.um-page-login').length > 0){
			this.doLoginText();
		}
		if( $('.um-page-password-reset').length > 0){
			console.log()
			this.doResetText();
		}
	}

	init() {

		var self = this;

		$(".form__other a").on("click", function(){
			self.is_form_two_open = true;
			self.open_form_two();
		});
	
		self.doFormScripts();

		jQuery(document).bind('gform_post_render', function(e){

			self.doFormScripts();

			$(".gform_wrapper form").find('input[type="submit"]').removeClass('disabled');

			 if (!$(".gform_wrapper").hasClass("gform_validation_error")) {
			 	$("form input[type='text']").val('');
			 }
			
		});

		$("#gform_2").on('submit', (e) => {
			// do validation
			var required_validated = false; // for first name and last name
			var is_validated = false; // for all other stuff
			var first = $("#input_2_1").val();
			var last = $("#input_2_2").val();

			var email = $("#input_2_6").val();
			var phone = $("#input_2_7").val();

			var address = $("#input_2_13").val();
			var city = $("#input_2_15").val();
			var postal_code = $("#input_2_16").val();

			if ( (email.length > 0) || (phone.length > 0)) {
				is_validated = true;
			}
			else if ( (address.length > 0) && (city.length > 0) && (postal_code.length > 0) ) {
				is_validated = true;
			}
			
			// first name and last name validation
			if ( (first.length <= 0) ) {
				$("#field_2_1").addClass('gfield_error');
			}
			else {
				$("#field_2_1").removeClass('gfield_error');
			}
			if ( (last.length <= 0) ) {
				$("#field_2_2").addClass('gfield_error');
			}
			else {
				$("#field_2_2").removeClass('gfield_error');
			}

			if ( (first.length > 0) && (last.length > 0)) {
				required_validated = true;
			}


			// decide whether to pass validation or nah.
			if (!is_validated) {
				$("#field_2_12").addClass("gfield_error");	
			}
			else {
				$("#field_2_12").removeClass("gfield_error");	
			}


			$(".gform_wrapper form").find('input[type="submit"]').removeClass('disabled');
			if (! (is_validated && required_validated) ) {
				return false;
			}
			else {
				required_validated = false;
				is_validated = false;
				return true;
			}
		});
	}

	doUpload(){
		let uploadInput = $('[type=file]');

		uploadInput.on('change', (e) => {
			let name = e.currentTarget.value.split(/\\|\//).pop();
			//document.styleSheets[document.styleSheets.length - 1].addRule('.gfield--upload label:after', `content: '${name}'` );
			this.uploadText.html(`Upload Resume<span class="gfield_required">*</span><span class="gfield_filename"><p>${name}</p></span>`);
		});
	}

	do_terms_open() {

		 var self = this;

		$(".open-terms").on("click", function(e){
			e.preventDefault();
			$(".theme-lightbox--form").find(".mfp-close").trigger("click");

			var $termsLink = $(this);
			var isFormTwoTerms = $termsLink.hasClass("open-terms--form-2");
			var timeout = isFormTwoTerms ? 450 : 0;
			
		});
	}

	clearInputPlaceholders() {
		$('input,textarea').focus(function(){
			$(this).data('placeholder',$(this).attr('placeholder'))
			.attr('placeholder','');
		}).blur(function(){
			$(this).attr('placeholder',$(this).data('placeholder'));
		});
	}

	disableButtonOnSubmit() {
		$(".gform_wrapper form").on('submit', function(){
			$(this).find('input[type="submit"]').addClass('disabled');
		});
	}

	removeErrorClassOnFocus() {
		$(".gfield_contains_required.gfield_error").find('input[type="text"]').on('focus', function(){
			$(this).closest('.gfield_contains_required').removeClass('gfield_error');
		});
	}

	doFloatingLabels() {

		$(".gfield--floating-label input[type='text'], .gfield--floating-label textarea").each(function(){

			if( $(this).val() != '' ) {
				$(this).closest('.gfield--floating-label ').addClass('has-value');
			}

		});

		$("select").on('select2:open', function (e) {
			$(this).closest('.gfield--floating-label').addClass('label-focused');
		});
		$("select").on('select2:close', function (e) {
			$(this).closest('.gfield--floating-label').removeClass('label-focused');
		});
		$("select").on('select2:select', function (e) {
			var data = e.params.data;
			$(this).closest('.gfield--floating-label ').addClass('has-value');
		})


			/*registration floating Labels*/
		$(".gfield--floating-label input[type='text'], .gfield--floating-label textarea").focus(function(){
			 $(this).closest('.gfield--floating-label').addClass('label-focused');
		}).blur(function(){
			$(this).closest('.gfield--floating-label').removeClass('label-focused');
			$(this).closest('.gfield--floating-label ').addClass('has-value');
			if( $(this).val() == '' ) {
				$(this).closest('.gfield--floating-label').removeClass('has-value');
			}
		});

	}

	doSelectInput() {
		// $("select").chosen({disable_search_threshold: 10});
		// $('.chosen-search-input').hide();
		$("select").select2({
			tags: false,
			minimumResultsForSearch: -1,
			placeholder: "",
			allowClear: false
		});

	}

	doLoginText(){
		$('.um-field-checkbox-option').html('Remember me');
		$('.um-link-alt').html('Forgot Password');
	}

	doResetText(){
		$('.um-button').val('GET NEW PASSWORD');
		$('.um-field-block').html('<div class="um-field-block">EMAIL ADDRESS</div>');

		$('.um-form-field').attr('placeholder', '');
	}

	doFormScripts() {
		if( $(window).innerWidth() > 480){
			this.doSelectInput();
		}
		this.doFloatingLabels();
		this.disableButtonOnSubmit();
		this.clearInputPlaceholders();
		this.removeErrorClassOnFocus();
		this.do_terms_open();
	}

}


module.exports = BjzmFormScripts;